"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBEstimatedTimePositive = function SvgBEstimatedTimePositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M105.506 52.374a2.107 2.107 0 01-1.489-3.597l12.363-12.363-7.432-7.431-5.83 5.823a2.107 2.107 0 01-2.978-2.978l7.333-7.32a2.178 2.178 0 012.979 0l10.368 10.417a2.107 2.107 0 010 3.007l-13.824 13.824c-.395.395-.931.617-1.49.618z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M59.279 143.69a58.492 58.492 0 01-44.71-20.728 2.108 2.108 0 113.217-2.726c18.654 21.866 51.152 25.323 73.99 7.87 22.836-17.451 28.035-49.716 11.836-73.459-16.199-23.742-48.137-30.668-72.716-15.77-24.579 14.9-33.213 46.42-19.657 71.764a2.107 2.107 0 01-3.716 1.981C-4.84 89.38-.184 60.746 18.91 42.621 38 24.495 66.839 21.33 89.407 34.886c22.568 13.555 33.323 40.5 26.291 65.869-7.031 25.37-30.122 42.933-56.447 42.936h.028z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M64.147 82.698a2.107 2.107 0 01-1.49-3.603L77.972 63.81a2.107 2.107 0 012.978 2.978L65.636 82.08c-.395.395-.93.618-1.49.618z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M59.279 133.147c-20.697-.033-39.037-13.343-45.485-33.01-6.448-19.667.45-41.251 17.11-53.533 16.66-12.281 39.319-12.487 56.198-.51a2.107 2.107 0 11-2.437 3.435C67.361 37.24 43.732 39.151 28.628 54.061s-17.321 38.512-5.258 55.974c12.064 17.461 34.924 23.739 54.213 14.888 19.29-8.852 29.438-30.276 24.067-50.809a45.202 45.202 0 00-9.02-17.238 2.109 2.109 0 013.225-2.718 49.43 49.43 0 019.876 18.896 48.005 48.005 0 01-46.452 60.128v-.035z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M59.356 92.905a7.727 7.727 0 01-5.886-12.736l.421-.477c.068-.073.14-.142.218-.204l.407-.344h.042a7.727 7.727 0 0112.427 4.755 7.727 7.727 0 01-7.629 9.006zm-2.458-10.277l-.288.316a3.512 3.512 0 00-.745 2.81 3.512 3.512 0 102.873-4.06 3.435 3.435 0 00-1.566.702l-.274.232z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M49.41 30.156a2.107 2.107 0 01-2.108-2.108V16.746a2.107 2.107 0 014.215 0v11.302a2.107 2.107 0 01-2.107 2.108zM69.289 30.156a2.107 2.107 0 01-2.108-2.108V25.4a2.107 2.107 0 114.215 0v2.648a2.107 2.107 0 01-2.107 2.108z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M75.906 17.561H42.779a2.107 2.107 0 01-2.108-2.107V2.107a2.107 2.107 0 014.215 0v11.24h28.912v-9.09H52.683a2.107 2.107 0 010-4.215h23.18c1.164 0 2.108.944 2.108 2.107v13.305a2.107 2.107 0 01-2.065 2.107z",
    fill: "#1B7"
  })));
};

var _default = SvgBEstimatedTimePositive;
exports["default"] = _default;